// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"b1c034ce","834":"1afd1ab0","847":"313ca9f4","998":"14f8570f"}[chunkId] + ".chunk.js";
};